module.exports = __webpack_public_path__ + "img/222.836a3eef.png";